import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './TopicSelector.css';

export default function JuniorHighGrammarGames() {
  const navigate = useNavigate();
  const { subject } = useParams();

  const basePath = subject ? `/junior-high/${subject}/grammar` : '/junior-high/grammar';
  const backUrl = subject ? (subject === 'spoken' ? '/junior-high/spoken' : '/junior-high/vocabulary') : '/junior-high';

  const games = [
    {
      id: 'who-did-it-singular',
      name: 'מי עשה את זה (יחיד)',
      icon: '🕵️',
      description: 'עבר - أنا/أنتَ/أنتِ/هو/هي'
    }
  ];

  return (
    <div className="topic-selector">
      <div className="topic-selector-container">
        <div className="header-with-back">
          <button onClick={() => navigate(backUrl)} className="back-to-grade-button">
            חזרה לבחירת נושא לימוד ↩
          </button>
          <h2 style={{ paddingTop: '20px' }}>משחקי דקדוק</h2>
        </div>

        <p className="topic-selector-subtitle">בחרו משחק דקדוק</p>

        <div className="vocab-games-container junior-high">
          <div className="paths-wrapper">
            <div className="path-container">
              <svg className="path-svg path-mobile" viewBox="0 0 400 1700" preserveAspectRatio="none">
                <path
                  d="M 200 50 Q 150 150, 200 250 Q 250 350, 200 450 Q 150 550, 200 650 Q 250 750, 200 850 Q 150 950, 200 1050 Q 250 1150, 200 1250 Q 150 1350, 200 1450 Q 250 1550, 200 1650"
                  fill="none"
                  stroke="rgba(255, 255, 255, 0.3)"
                  strokeWidth="6"
                  strokeDasharray="15,10"
                  strokeLinecap="round"
                />
              </svg>
              <svg className="path-svg path-desktop" viewBox="0 0 1400 900" preserveAspectRatio="none">
                <path
                  d="M 175 75 Q 250 90, 425 175 T 675 275 T 925 375 Q 950 425, 825 525 T 575 675 T 325 825"
                  fill="none"
                  stroke="rgba(255, 255, 255, 0.3)"
                  strokeWidth="6"
                  strokeDasharray="15,10"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>

          {games.map((game) => (
            <div
              key={game.id}
              className="vocab-game-bubble"
              onClick={() => navigate(`${basePath}/${game.id}`)}
            >
              <div className="bubble-circle">
                <div className="bubble-icon">{game.icon}</div>
              </div>
              <div className="bubble-text">
                <h3 className="bubble-name">{game.name}</h3>
                <p className="bubble-description">{game.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
